jQuery(document).ready(function($) {

  $('.search-wrap > .btn-search').click(function() {
    $('.nav-bar').toggleClass('open-search');
    setTimeout(function () {
      $('.search-field').focus();
    }, 100);
  });

  $('.hidetext button.read_more').click(function() {
    var $this = $(this);
    var $parent = $(this).closest('.hidetext');
    var $hide_content = $parent.find('.hide_content');

    $this.toggleClass('less_more');

    $hide_content.stop(true).slideToggle(500);
  });

  $('.hidemobile button.read_more').click(function() {
    var $this = $(this);
    var $parent = $(this).closest('.hidemobile');
    var $hide_content = $parent.find('.hide_content');

    $this.toggleClass('less_more');

    $hide_content.stop(true).slideToggle(500);
  });

  var $home_top_slider = new Swiper('.home-top-slider', {
    speed: 800,
    autoHeight: true,
    pagination: $('.home-top-slider .swiper-pagination'),
    paginationElement: 'button',
    bulletClass: 'bullet',
    bulletActiveClass: 'active',
    paginationClickable: true,
    nextButton: $('.home-top-slider .btn-next'),
    prevButton: $('.home-top-slider .btn-prev')
  });

  var $casinos_fluid_slider = new Swiper('.casinos-fluid-slider', {
    speed: 800,
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
    spaceBetween: $('.casinos-fluid-slider').data("space"),
    pagination: $('.casinos-fluid-slider .swiper-pagination'),
    paginationElement: 'button',
    bulletClass: 'bullet',
    bulletActiveClass: 'active',
    paginationClickable: true,
    nextButton: $('.casinos-fluid-slider .btn-next'),
    prevButton: $('.casinos-fluid-slider .btn-prev')
  });

  var $slots_top_slider = new Swiper('.slots-top-slider', {
    speed: 800,
    slidesPerView: 'auto',
    pagination: $('.slots-top-slider .swiper-pagination'),
    paginationElement: 'button',
    bulletClass: 'bullet',
    bulletActiveClass: 'active',
    paginationClickable: true,
    nextButton: $('.slots-top-slider .btn-next'),
    prevButton: $('.slots-top-slider .btn-prev')
  });

  var $review_gallery_sm = new Swiper('.review-gallery-sm', {
    speed: 800,
    slidesPerView: 'auto',
    pagination: $('.review-gallery-sm .swiper-pagination'),
    paginationElement: 'button',
    bulletClass: 'bullet',
    bulletActiveClass: 'active',
    paginationClickable: true,
  });

  var $slots_advert = new Swiper('.slots-advert', {
    speed: 800,
    slidesPerView: 'auto',
    simulateTouch: false,
    nextButton: $('.slots-advert .btn-next'),
    prevButton: $('.slots-advert .btn-prev')
  });

  $('.raty-read-only').each(function(i, e) {
    $(e).raty({
      score: function() {
        return $(e).attr('data-score');
      },
      readOnly: true,
      path: variables.template_directory + '/dist/images/icons/',
      starHalf: 'star-half.svg',
      starOn: 'star-on.svg',
      starOff: 'star-off.svg',
      space: false,
      round : { down: 0.25, full: 0.6, up: 0.76 },
    });
  });

  $('button.btn-menu').click(function() {
    $('body').toggleClass('menu-opened');
  });

  $('body').on('click', 'button.btn-extra-menu, .btn-close-extra-menu', function() {
    if($('body').hasClass('extra-menu-opened')) {
      $("div.nav-backdrop").remove();
    }
    else {
      $('body').append('<div class="nav-backdrop btn-close-extra-menu"></div>');
    }
    $('body').toggleClass('extra-menu-opened');
  });

  $(".touchevents .menu-item-has-children > a").on('touchstart', function(e) {
    var $parent = $(this).parent();

    if ($parent.hasClass('open')) {
      $parent.removeClass('open');
    } else {
      $(".menu-item-has-children.open").removeClass('open');
      $parent.addClass('open');
      return false;
    }
  });

  $('.site-footer .widget h4').click(function() {
    var $parent = $(this).parent();

    $parent.toggleClass('open');
    $parent.find('ul').stop(true).slideToggle(500);
  });

  $('.btn-tgl-slot-info').click(function() {
    var $elems = {
      'this': $(this),
      'parent': $(this).closest('.review-content')
    };

    $elems.this.toggleClass('less_more');
    $elems.parent.toggleClass('opened-text');
    return false;
  });

  $('.btn-tgl-expand').click(function() {

    var $elems = {
      'flag' : false,
      'this' : $(this),
      'label': $(this).find('.label'),
      'extend' : $(this).find('.label').html(),
      'minimize' : $(this).data('minimize'),
      'icon' : $(this).find('.icon'),
      'extend_icon' : 'icon-22',
      'minimize_icon' : 'icon-23',
      'parent' : $(this).closest('.review-content'),
      'col_text' : $('.col-text'),
      'col_iframe' : $('.col-iframe')
    };
    

    $elems.label.html($elems.minimize);
    $elems.this.data('minimize', $elems.extend);


    if( $elems.icon.hasClass($elems.extend_icon) ) {
      $elems.icon.removeClass($elems.extend_icon).addClass($elems.minimize_icon);
       $elems.col_text.addClass('d-none');
       $elems.col_iframe.addClass('col-md-12');
    }
    else {
      $elems.icon.removeClass($elems.minimize_icon).addClass($elems.extend_icon);
      $elems.col_text.removeClass('d-none');
      $elems.col_iframe.removeClass('col-md-12');
    }
    
    $slots_advert.update();
  });

  $('[data-toggle="tooltip"]').tooltip();

  smoothScrolling('.review-top a.nav-link');

  if( $('[data-lightbox]').length ) {
    lightbox.option({
      'showImageNumberLabel': false,
    });
  }

  if( $('.sidebar-sticky').length ) {
    $('.sidebar-sticky').theiaStickySidebar({
      additionalMarginTop: $('.site-header').outerHeight(),
      containerSelector: $('.sticky-wrapper')
    });
  }
  
  function smoothScrolling(selector, offset_top) {
    var $offset_top = offset_top || 0;

    $(selector + '[href*="#"]:not([href="#"])').click(function() {
      var $target = $(this.hash),
        $targetCount = this.hash.slice(1) - 1;

      $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');

      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top - $offset_top
        }, 600);

        return false;
      }
    });
  }



  // Ajax-search function
  $(".ajax-searchform").bind("keyup", ".search_field", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var value = $(this).find(".search-field").val();
    var search_result = $(this).closest(".form-search").find(".search-result");
    var search_output = $(this).closest(".form-search").find(".search-output");
    var search_preview = $(this).closest(".form-search").find(".search-preview");
    var loading = $(this).closest(".form-search").find(".search-result .loading");
    var data = {
      action: "ajax_search",
      value: value
    };

    if (value.length > 0) {
      search_result.show();
      $.ajax({
        url: ajax_url,
        data: data,
        dataType: 'json',
        type: 'get',
        beforeSend: function() {
          search_output.empty();
          loading.show();
        },
        success: function(response) {
          loading.hide();
          search_preview.hide();
          search_output.empty();
          search_output.append(response.html);
          if (!response.count) { 
            search_preview.show();
          }
        },
        error: function() {
          search_output.empty();
          loading.hide();
          search_output.html("<p class='search-error'>Någonting gick fel med sökningen</p>");
        }

      });
    } else {
      loading.hide();
      search_output.empty();
      search_preview.show();
    }
  });
  
  // Ajax-siderbar searcj function
  $(".ajax-sidebar-searchform").bind("keyup", ".search_field", function(e){
    e.preventDefault();
    e.stopPropagation();
    var value = $(".ajax-sidebar-searchform").find(".form-control").val();
    var post_type = $(".ajax-sidebar-searchform").find(".form-control").data("posttype");  
    var search_result = $(this).closest(".ajax-sidebar-searchform").find(".search-result");
    var search_output = search_result.find(".search-output");
    var loading = search_result.find('.loading');
    var data = {
        action: "ajax_sidebar_search",
        value: value,
        post_type: post_type
    };

    if(value.length > 0){
      search_result.show();
      $.ajax({
        url: ajax_url,
        data: data,
        dataType: 'json',
        type: 'get',
        beforeSend: function(){
          search_output.empty();
          loading.show();
        },
        success: function(response){
          loading.hide();
          search_output.empty();
          search_output.append(response);
        },
        error:function(){
          search_output.empty();
          loading.hide();
          $('.search-output').html('<p>Någonting gick fel med sökningen</p>');
        }
      });
    } else {
      search_output.empty();
      search_result.hide();
    }
    return false;
  });

  $('button.btn-play-free').click(function() {
    var $this = $(this),
        $iframe_wrap = $this.closest('.slots-iframe-wrap'),
        $postID = $(this).data("post-id"),
        $data = {
          action: "ajax_iframe_callback",
          post_id: $postID,
        };
        // $href = $(this).data("href"),
        // $modalID = $(this).attr("href");
    $.ajax({
      url: ajax_url,
      data: $data,
      dataType: 'json',
      type: 'POST',
      beforeSend: function() {
        $iframe_wrap.find('.thumb').addClass('d-none');
        $iframe_wrap.find('.loading').addClass('d-inline-block');
        $iframe_wrap.find('.slots-buttons-wrap').removeClass('d-flex').addClass('d-none');
      },
      success: function(response){
        $iframe_wrap.find('.loading').removeClass('d-inline-block');
        $iframe_wrap.find('.embed-responsive').append(response);
      },
      error:function(){
      }
    });

    // $($modalID).data("post-id", $postID).data("href", $href);
  });

  // Ajax Modal Function
  $cur_post_id = undefined;
  $('#slot-modal').on('show.bs.modal', function (e) {
    
    var $this = $(this),
        $post_id = $this.data("post-id"),
        $href = $this.data("href"),
        $iframe_output = $this.find('.iframe-output'),
        $iframe_loading = $this.find('.iframe-loading'),
        $raty = $this.find('.raty'),
        $data = {
          action: "ajax_modal_callback",
          post_id: $post_id,
          href: $href
        };

    if( $cur_post_id !== $post_id ) {
      $.ajax({
        url: ajax_url,
        data: $data,
        dataType: 'json',
        type: 'get',
        beforeSend: function(){
          $iframe_loading.show();
          $iframe_output.empty();
        },
        success: function(response){
          $iframe_loading.hide();
          $iframe_output.append(response);
          $raty = $this.find('.raty');
          $raty.each(function(i, e) {
            $(e).raty({
              score: function() {
                return $(e).attr('data-score');
              },
              readOnly: true,
              path: variables.template_directory + '/dist/images/icons/',
              starHalf: 'star-half.svg',
              starOn: 'star-on.svg',
              starOff: 'star-off.svg',
              space: false,
              round : { down: 0.25, full: 0.6, up: 0.76 },
            });
          });
          $cur_post_id = $post_id;
        },
        error:function(){
          $iframe_output.empty();
          $iframe_loading.hide();
          $('.search-output').html('<p>Någonting gick fel med sökningen</p>');
        }
      });
    }
  });
});


if(navigator.userAgent.indexOf("Speed Insights") == -1) {
  // FB Async Init
  window.fbAsyncInit = function() {
  FB.init({appId: '1433170403574423', status: true, cookie: true,
           xfbml: true});
  };
  (function() {
  var e = document.createElement('script'); e.async = true;
  e.src = document.location.protocol +
    '//connect.facebook.net/nl_NL/all.js';
  document.getElementById('fb-root').appendChild(e);
  }());
}